import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, AlertController, IonInput } from '@ionic/angular';
import { CartService } from '../../services/cart.service';
import { Decimal } from "decimal.js";

@Component({
    selector: 'app-checkout-payment-on-account',
    templateUrl: './checkout-payment-on-account.page.html',
    styleUrls: ['./checkout-payment-on-account.page.scss'],
})
export class CheckoutPaymentOnAccountPage implements OnInit {

    @ViewChild('purchase_order_number_input', { static: false }) purchase_order_number_input: IonInput;

    credit_limit_exceeded = false;
    customer_name = "";
    cart = null;

    params = {
        awaiting_payment_method: 'on_account'
    };

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cartService: CartService,
    ) { }

    ngOnInit() {

        this.cartService.get().then((cart) => {
            if(cart) {

                this.cart = cart;

                if(cart["organisation"] && cart["organisation"].credit_details) {
                    if(cart["organisation"].credit_details["credit_limit"]) {

                        // organisation amount owning & cart amount due exceeds organisation credit limit
                        if(Number(new Decimal(cart["organisation"].credit_details.amount_owing).plus(new Decimal(cart["amount_due"]))) > cart["organisation"].credit_details.credit_limit) {
                            this.credit_limit_exceeded = true;
                            this.customer_name = cart["organisation"]["title"];
                        }

                    }
                }
                else if(cart["person"] && cart["person"].credit_details) {
                    if(cart["person"].credit_details.credit_limit) {

                        // person amount owning & cart amount due exceeds person credit limit
                        if(Number(new Decimal(cart["person"].credit_details.amount_owing).plus(new Decimal(cart["amount_due"]))) > cart["person"].credit_details.credit_limit) {
                            this.credit_limit_exceeded = true;
                            if(cart["person"].full_name) {
                                this.customer_name = cart["person"].full_name + " (#" + cart["person"].number + ")";
                            }
                            else {
                                this.customer_name = "(#" + cart["person"].number + ")";
                            }
                        }

                    }
                }

            }
        });

    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        setTimeout(() => {
            if(this.purchase_order_number_input) {
                this.purchase_order_number_input.setFocus();
            }
        }, 200);
    }

    placeOrder() {

        if(this.credit_limit_exceeded) {
            this.presentExceedCreditLimitConfirmation()
        }
        else {
            this.modalController.dismiss(this.params);
        }

    }

    close() {
        this.modalController.dismiss();
    }

    async presentExceedCreditLimitConfirmation() {
        const alert = await this.alertController.create({
            header: "Credit limit exceeded",
            message: "Placing this order will exceed the customer's credit limit.<br><br>Are you sure you want to place the order?",
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: () => {
                        this.modalController.dismiss(this.params);
                    }
                }
            ],
        });
        await alert.present();
    }

}
